<div class="container-component">
  <app-header-component [title]="title" [description]="description">
  </app-header-component>

  <div class="bd-menu">
    <app-menu-component [content]="content" [urlComponent]="urlComponent"></app-menu-component>
  </div>

  <div class="bd-content">
    <h2 [id]="content[1].id" class="title-2 link-target empty-title"></h2>
    <div class="container-p1">
      <div class="container-img"></div>
      <div>
        <h6>
          La versión 5 (v.5) de la Biblioteca Digital de Componentes (BDC) le permitirá implementar los distintos componentes que forman parte del entorno www.gov.co.
        </h6>
        <p class="mb-0 text-1">
          Usted puede tomar cada componente por separado -uno a uno- y solo el que necesite o aplique para su caso; funcionalidad que solo está disponible en esta última versión (v.5) de la BDC.
        </p>
      </div>
    </div>

    <h2 [id]="content[2].id" class="link-target">
      ¿Cómo integrarse al Portal Único del Estado Colombiano (WWW.GOV.CO)?
    </h2>

    <p class="text-1">Existen diferentes opciones para aplicar en su sitio web los estándares del Portal Único del Estado Colombiano (www.gov.co) a través de la Biblioteca Digital de componentes (BDC): descarga del código fuente en el repositorio o URL's de acceso a las librerías.<br/><br/></p>
    <p class="text-1">Por tanto, para hacer uso de cualquier componente de la BDC e implementarlo en el sitio web de su entidad, usted puede:</p>

    <ul class="list-uses">
      <li>
        <div>          
          <span class="icon-file-copy"></span>
        </div>
        <h6>Copiar el código</h6>
      </li>
      <li>
        <div>          
          <span class="icon-download"></span>
        </div>
        <h6>Descargar el CSS, el <br>HTML y el JavaScript</h6>
      <li>
        <div>          
          <span class="icon-code-blocks"></span>
        </div>
        <h6>Importarlos a <br>su página web</h6>
      </li>
    </ul>

    <p class="text-1 m-b-71">También puede copiar la dirección enlace con el dominio de www.gov.co.</p>

    <h2 [id]="content[3].id" class="link-target">
      {{content[3].nombre}}
      <span class="underline-title"></span>
    </h2>
    <p class="text-1 m-b-30">Importe los siguientes elementos desde su index.html.</p>
    <h6 id="instalacion" class="link-target subtitle-begin">Instalación</h6>

    <div class="m-b-30" aria-label="Código fuente" tabindex="0">
      <app-code-render [code]="defaults['css_cdn']" [language]="'html'"></app-code-render>
    </div>
    <div class="m-b-40" aria-label="Código fuente" tabindex="0">
      <app-code-render [code]="defaults['utils.js']" [language]="'html'"></app-code-render>
    </div>

    <h6 id="dependencia" class="link-target subtitle-begin">Dependencias</h6>

    <p class="text-1 m-b-30">Bootstrap v.5.0.2 </p>

    <p class="text-1 m-b-20">
      Descargue la fuente iconográfica, para los componentes que así lo requieran, desde el repositorio de código GIT.
    </p>
    <a href="#" role="button" href="{{fuenteIconografica}}" class="btn-govco fill-btn-govco icon-btn-govco m-b-20 ms-2" 
      target="_blank" style="width: 168px; height: 42px;">
      <span class="govco-icon govco-gitlab" aria-hidden="true"></span>
      <span>Ver en GitLab</span>
    </a>
    <p class="text-1 m-b-20">
      Recuerde que puede acceder al documento Readme.md para hacer un uso óptimo de los componenentes del BDC.
    </p>

    <div class="m-b-30" aria-label="Código fuente">
      <app-code-render [code]="defaults['css_bootstrap']" [language]="'html'"></app-code-render>
    </div>
    <div class="m-b-80" aria-label="Código fuente" tabindex="0">
      <app-code-render [code]="defaults['js_bootstrap']" [language]="'html'"></app-code-render>
    </div>

    <h2 [id]="content[4].id" class="link-target">
      {{content[4].nombre}}
      <span class="underline-title"></span>
    </h2>

    <p class="text-1">
      Al vincular su entidad al Portal Único del Estado Colombiano (www.gov.co) disfrutará de los siguientes beneficios:
    </p>
    <div class="row advantage m-b-80">
      <div class="col- col-sm-8 col-md-8 col-lg-6 col-xl-4 my-3 p-3">
        <div class="text-center container-img-ventajas img1">
        </div>
        <p class="text-left mt-3 text-1">Su integración a los lineamientos de Gobierno Digital será más sencilla.</p>
      </div>
      <div class="col- col-sm-8 col-md-8 col-lg-6 col-xl-4 my-3 p-3">
        <div class="text-center container-img-ventajas img2">
        </div>
        <p class="text-left mt-3 text-1">Su portal electrónico será más ágil.</p>
      </div>
      <div class="col- col-sm-8 col-md-8 col-lg-6 col-xl-4 my-3 p-3">
        <div class="text-center container-img-ventajas img3">
        </div>
        <p class="text-left mt-3 text-1">Sus productos estarán más actualizados.</p>
      </div>
    </div>

    <h2 [id]="content[5].id" class="link-target">
      {{content[5].nombre}}
      <span class="underline-title"></span>
    </h2>

    <p class="text-1 m-b-20">
      Con estos paquetes puede verificar si sus páginas están cumpliendo con los estándares de calidad actuales.
    </p>
    <div class="row text-1">
      <div class="col-11 m-2 p-4 container-kit">
        <div class="text-center container-img img4">
        </div>
        <div>
          <div class="container-description">
            <span>
              <a [href]="kitUX_url" target="_blank">Kit de usabilidad/herramientas</a>
            </span>
            <p>
              Compruebe que su producto digital es fácil de usar y ofrece una buena experiencia de usuario.
            </p>
            <div>
              <a class="mr-4" [href]="kitUX_urlPDF" target="_blank">Ver PDF</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row text-1">
      <div class="col-11 m-2 p-4 container-kit">
        <div class="text-center container-img img5">
        </div>
        <div>
          <div class="container-description">
            <span>
              <a [href]="kitAX_url" target="_blank">Kit de accesibilidad/herramientas</a>
            </span>
            <p>
              Verifique que sus sistemas de información cumplen con los criterios de Accesibilidad para el Contenido Web (WCAG 2.1) como textos comprensibles, funcionalidades operables, herramientas compatibles, etc.
            </p>
            <div>
              <a class="mr-4" [href]="kitAX_urlPDF" target="_blank">Ver PDF</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row text-1 m-b-64">
      <div class="col-11 m-2 p-4 container-kit">
        <div class="text-center container-img img6">
        </div>
        <div>
          <div class="container-description">
            <span>
              <a [href]="kitUI_url" target="_blank">Kit UI V.9</a>
            </span>
            <p>
              Use y aplique adecuadamente los componentes de la BDC siguiendo las indicaciones de los expertos en diseño y teniendo en cuenta los consejos de usabilidad, accesibilidad y buenas prácticas de implementación.
            </p>
            <div>
              <a class="mr-4" [href]="kitUI_urlPDF" target="_blank">Ver PDF</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>